// extracted by mini-css-extract-plugin
var _1 = "Emoji-module__char--jafDD";
var _2 = "Emoji-module__large--seayr";
var _3 = "Emoji-module__medium--pROkM";
var _4 = "Emoji-module__small--NlPeK";
export { _1 as "char", _2 as "large", _3 as "medium", _4 as "small" }
